export default function Style(){
  return (
    <style>
      {`
       .lh-36 {
  line-height: 36px;
}

@media screen and (max-width: 1543px) {
  .fs-24-36 {
    font-size: 22px !important;
    line-height: 33px !important;
  }
}

@media screen and (min-width: 1543px) {
  .fs-24-36 {
    font-size: 24px !important;
    line-height: 36px !important;
  }
}
 .color {
   color: #1b1b1b;
 }

 .fw-400 {
   font-weight: 400 !important;
 }

 .fw-600 {
   font-weight: 600;
 }


 @media (min-width: 1543px) {
   .res-fs-size {
     font-size: 48px;
     line-height: 60px;
   }

   .responsiveText {
     font-size: 24px;
     line-height: 36px;
   }
 }


 @media (max-width: 1534px) {
   .res-fs-size {
     font-size: 44px;
     line-height: 55px;
   }

   .responsiveText {
     font-size: 22px;
     line-height: 33px;
   }
 }


 @media (max-width: 1024px) {
   .res-fs-size {
     font-size: 38px;
     line-height: 48px;
   }
    .btn-stays {
     width: 100%;
     margin-bottom: 30px;
   }
 }

 @media (max-width: 768px) {
   .res-fs-size {
     font-size: 32px;
     line-height: 40px;
   }

   .btn-stays {
     width: 100%;
     margin-bottom: 30px;
   }
 }

        `}
    </style>
  );
}
